import { Checkbox as RCheckbox } from "radix-ui";
import type { ReactNode } from "react";

import { Icon } from "../icons";
import styles from "./Checkbox.module.css";
import { cx } from "../lib/cx";

export type CheckboxProps = {
  readonly checked: boolean;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly onCheckedChange: (checked: boolean) => void;
  readonly tone?: "accent" | "done";
};

export const Checkbox = ({
  checked,
  children,
  className,
  onCheckedChange,
  tone = "accent",
}: CheckboxProps) => (
  <RCheckbox.Root
    checked={checked}
    className={cx(styles.toggle, tone === "done" && styles.done, className)}
    onCheckedChange={(value) => onCheckedChange(value === true)}
  >
    <span className={styles.box}>
      <RCheckbox.Indicator>
        <Icon.Check size={11} />
      </RCheckbox.Indicator>
    </span>
    {children}
  </RCheckbox.Root>
);
